import { useMemo } from 'react';
import { BASE_STORE_CONFIG, CUSTOMIZED_STORE_CONFIG_BY_ID } from '../constant';
import LogoImg from '../image/artly-white-logo.png';
import ArtlyBaristaBotImg from '../image/artly-bot-logo.svg';
import { ARTLY_LOGO } from '../constant';

export function useContainerStyle(props) {
    const {
        screenWidth,
        screenHeight,
        BG_WIDTH,
        BG_HEIGHT,
    } = props;

    return useMemo(() => {
        if ((screenWidth / screenHeight) < (BG_WIDTH / BG_HEIGHT)) {
            const marginHeight = (screenHeight - (screenWidth * BG_HEIGHT) / BG_WIDTH) / 2;
            const marginStr = `${marginHeight}px`;
            return {
                marginTop: marginStr,
                marginBottom: marginStr,
            };
        }

        const marginWidth =
            (screenWidth - (BG_WIDTH * screenHeight) / BG_HEIGHT) / 2;
        const marginStr = `${marginWidth}px`;
        return {
            marginLeft: marginStr,
            marginRight: marginStr,
        };
    }, [
        screenWidth,
        screenHeight,
        BG_WIDTH,
        BG_HEIGHT,
    ]);
}

export function useStoreConfig(props) {
    const {
        storeId,
    } = props;

    return useMemo(() => {
        // A helper function to transform the flags from top level to each video config
        // if not defined in the video config
        const transformFlags = (config) => {
            if (!config) {
                return config;
            }
            const flags = [
                'needAttachedLogo',
                'needAttachedLogos',
                'needAttachedSns',
                'needAttachedQrcode',
            ];
            const videoConfigFields = [
                'landscapeVideo',
                'portraitVideo',
                'landscapeFallbackVideo',
                'portraitFallbackVideo',
            ];

            if (config.needAttachedLogos == null) {
                config.needAttachedLogos = [];
            }

            if (config.needLogosInWaitingPage == null) {
                config.needLogosInWaitingPage = [];
            }

            // transform static 'ARTLY' to a url
            config.needAttachedLogos = config.needAttachedLogos.map(url => url === ARTLY_LOGO ? LogoImg : url);
            config.needLogosInWaitingPage = config.needLogosInWaitingPage.map(url => url === ARTLY_LOGO ? ArtlyBaristaBotImg : url);

            videoConfigFields.forEach((field) => {
                flags.forEach((flag) => {
                    if (config[field][flag] == null) {
                        config[field][flag] = config[flag] || false;
                    } else if (flag === 'needAttachedLogos') {
                        config[field][flag] = config[field][flag].map(url => url === ARTLY_LOGO ? LogoImg : url);
                    } else if (flag === 'needLogosInWaitingPage') {
                        config[field][flag] = config[field][flag].map(url => url === ARTLY_LOGO ? ArtlyBaristaBotImg : url);
                    }
                });
            });
            return config;
        }
        const baseConfig = BASE_STORE_CONFIG;
        const storeConfig = CUSTOMIZED_STORE_CONFIG_BY_ID[storeId];
        if (storeConfig) {
            return transformFlags(Object.assign({}, baseConfig, storeConfig));
        }
        return transformFlags(baseConfig);
    }, [storeId]);
}
